import * as React from 'react'

// Components
import Step from '@components/Step'
import { Button } from '@metrisk/react_metrisk-components'
import { FormattedMessage } from 'react-intl'

const FormStep = (props: any) => {
  const { id, hasPrevStep, prevStep, submitPoint, submitting, nextStep, children, valid, ...other } = props

  const footer = {
    actions: [
      hasPrevStep && (
        <Button key={'prev-btn'} type={'Tertiary'} onClick={prevStep} disabled={submitting.inProgress}>
          <FormattedMessage
            defaultMessage='Prev'
          />
        </Button>
      ),
      <Button
        key={'next-btn'}
        type={'Primary'}
        submit={submitPoint}
        disabled={!valid || submitting.inProgress}
        onClick={submitPoint ? null : nextStep}
      >
        { submitPoint
          ? ( submitting.inProgress
            ? <FormattedMessage defaultMessage='Submitting...'/>
            : <FormattedMessage defaultMessage='Submit' />
          ) : <FormattedMessage defaultMessage='Next' />
        }
      </Button>,
    ],
  }

  return (
    <Step id={id} footer={footer} {...other}>
      {children}
    </Step>
  )
}

export default FormStep
